import { takeLatest } from '@redux-saga/core/effects'
import { call, put, select } from 'redux-saga/effects'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import { TimelineConstants } from '../store/timeline.constants'
import { setState } from '../../vitals/store/vitals.actions'
import { ITimelineState } from '../store/timeline.types'
import { getPcrIdSelector } from '../../home/selectors/getPcrId.selector'
import { getServiceIdSelector } from '../../user/selectors/getServiceId.selector'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IPcr } from '../../pcr/store/pcr.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* setPatientVitalItemData() {
  const timeline: ITimelineState = yield select(getPatientTimelineSelector)
  const { vitalItem } = timeline
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  if (pcrID) {
    try {
      if (vitalItem) {
        const pcrDocsService = new PcrDocsService(serviceId)
        const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
        const vitalState = pcrDoc.patient.patientVitals?.find((state) => {
          if (vitalItem.labelHeader) {
            state.time = vitalItem.labelHeader
          }
          return state.key === vitalItem.key
        })

        if (vitalState) {
          const currentVital = { ...vitalState }

          if (currentVital.customVitalLabel1 || currentVital.customVitalLabel2) {
            currentVital.__customVitalLabelExists = true
          }

          yield put(setState(currentVital))
        } else yield put(throwPcrException(`vital state not found for key ${vitalItem.key}`))
      }
    } catch (e) {
      yield put(throwPcrException(`setPatientVitalItemData() error: ${e}`))
    }
  }
}

export function* setPatientVitalItemDataSaga() {
  yield takeLatest([TimelineConstants.SET_VITAL_ITEM], performWithMutexHOG, setPatientVitalItemData)
}
